import { render, staticRenderFns } from "./PizzaChartAbandoned.vue?vue&type=template&id=de9f7fc4"
import script from "./PizzaChartAbandoned.vue?vue&type=script&lang=js"
export * from "./PizzaChartAbandoned.vue?vue&type=script&lang=js"
import style0 from "./PizzaChartAbandoned.vue?vue&type=style&index=0&id=de9f7fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports